// extracted by mini-css-extract-plugin
module.exports = {"container":"Sj3iY","button":"_17VzN","actionsContainer":"_1ntcb","center":"_2e-1a","right":"_1OE-u","triangle":"_1rdvt","actionsPadding":"_3fNyK"};